import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

/**
 * Styling for the Account Overview Customizations card body: the settings grid (label on top,
 * "Manage" link below, matching the read-mode field layout of the other cards) plus the "Manage"
 * link affordance. All tokens come from `THEME`; the literal 15px matches the field value size in
 * `overviewFieldStyles`.
 */
export const customizationsCardStyles = StyleSheet.create({
	grid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
		gap: `${THEME.spacing.md}px ${THEME.spacing.lg}px`,
		marginTop: THEME.spacing.md,
	},
	// The Blog URL value renders as a real anchor, so it needs the link color the Button-based
	// "Manage" affordance gets from components-v2.
	blogLink: {
		color: THEME.colors.primary.main,
		fontSize: 15,
		lineHeight: 1.3,
		overflowWrap: 'anywhere',
		textDecoration: 'none',
		':hover': {
			color: THEME.colors.hover.main,
		},
	},
	manageLink: {
		alignItems: 'center',
		alignSelf: 'flex-start',
		color: THEME.colors.primary.main,
		cursor: 'pointer',
		display: 'inline-flex',
		fontSize: 15,
		gap: THEME.spacing.xs,
		// Override the components-v2 Button's fixed height/padding so "Manage" sits inline like a link.
		height: 'auto',
		padding: 0,
		textDecoration: 'none',
		whiteSpace: 'nowrap',
		':hover': {
			color: THEME.colors.hover.main,
		},
	},
});
